import { useEffect } from "react";
import emitter, { EVENTS } from "lib/emitter";

export function useHideFooter() {
  useEffect(() => {
    Promise.resolve().then(() => {
      emitter.emit(EVENTS.FOOTER_HIDE);
    });

    return () => {
      emitter.emit(EVENTS.FOOTER_SHOW);
    };
  }, []);
}
